export default __webpack_public_path__ + "static/media/completedstep.494330f8.svg";